// GuidedTour Component - Interactive product tour with react-joyride
import React, { useState } from 'react';
import Joyride, { STATUS } from 'react-joyride';

const GuidedTour = ({ run = false, onComplete }) => {
  const [stepIndex, setStepIndex] = useState(0);

  const steps = [
    {
      target: 'body',
      content: (
        <div className="text-center">
          <div className="w-16 h-16 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
            </svg>
          </div>
          <h2 className="text-xl font-bold mb-2">Bienvenue sur OptiTrajet!</h2>
          <p className="text-gray-600">
            Découvrez votre nouvel assistant comptable intelligent. 
            Nous allons vous faire visiter rapidement.
          </p>
        </div>
      ),
      placement: 'center',
      disableBeacon: true,
    },
    {
      target: '[data-tour="sidebar-trips"]',
      content: (
        <div>
          <h3 className="font-bold text-lg mb-2">Vos Trajets</h3>
          <p className="text-gray-600">
            Enregistrez tous vos déplacements professionnels. 
            Entrez la distance manuellement et associez un client pour la facturation.
          </p>
        </div>
      ),
      placement: 'right',
    },
    {
      target: '[data-tour="sidebar-expenses"]',
      content: (
        <div>
          <h3 className="font-bold text-lg mb-2">Vos Dépenses</h3>
          <p className="text-gray-600">
            Gérez carburant, péages, parking et entretien. 
            Utilisez le <strong>Scan IA</strong> pour extraire automatiquement les données de vos reçus!
          </p>
        </div>
      ),
      placement: 'right',
    },
    {
      target: '[data-tour="sidebar-invoices"]',
      content: (
        <div>
          <h3 className="font-bold text-lg mb-2">Facturation</h3>
          <p className="text-gray-600">
            Créez des factures professionnelles en quelques clics. 
            Numérotation automatique et export PDF inclus.
          </p>
        </div>
      ),
      placement: 'right',
    },
    {
      target: '[data-tour="sidebar-accounting"]',
      content: (
        <div>
          <h3 className="font-bold text-lg mb-2">Comptabilité</h3>
          <p className="text-gray-600">
            Exportez vos récapitulatifs mensuels en PDF ou Excel. 
            Conformes à la loi française 2026!
          </p>
        </div>
      ),
      placement: 'right',
    },
    {
      target: '[data-tour="sidebar-settings"]',
      content: (
        <div>
          <h3 className="font-bold text-lg mb-2">Paramètres</h3>
          <p className="text-gray-600">
            Configurez votre profil, entreprise et abonnement. 
            Passez à Pro pour débloquer toutes les fonctionnalités!
          </p>
        </div>
      ),
      placement: 'right',
    },
    {
      target: 'body',
      content: (
        <div className="text-center">
          <div className="w-16 h-16 bg-gradient-to-r from-green-500 to-emerald-500 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h2 className="text-xl font-bold mb-2">C'est parti!</h2>
          <p className="text-gray-600">
            Vous êtes prêt à optimiser votre gestion comptable. 
            Commencez par ajouter votre premier trajet!
          </p>
        </div>
      ),
      placement: 'center',
    },
  ];

  const handleJoyrideCallback = (data) => {
    const { status } = data;

    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      // Tour completed or skipped
      localStorage.setItem('optitrajet_tour_completed', 'true');
      if (onComplete) {
        onComplete();
      }
    }
  };

  const joyrideStyles = {
    options: {
      primaryColor: '#8b5cf6',
      zIndex: 10000,
      arrowColor: '#fff',
      backgroundColor: '#fff',
      overlayColor: 'rgba(0, 0, 0, 0.5)',
      textColor: '#333',
    },
    buttonNext: {
      backgroundColor: '#8b5cf6',
      borderRadius: '8px',
      padding: '10px 20px',
      fontSize: '14px',
    },
    buttonBack: {
      color: '#666',
      marginRight: '10px',
    },
    buttonSkip: {
      color: '#999',
    },
    tooltip: {
      borderRadius: '12px',
      padding: '20px',
    },
    tooltipContainer: {
      textAlign: 'left',
    },
  };

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous
      showProgress
      showSkipButton
      scrollToFirstStep
      disableOverlayClose
      locale={{
        back: 'Précédent',
        close: 'Fermer',
        last: 'Terminer',
        next: 'Suivant',
        skip: 'Passer',
      }}
      styles={joyrideStyles}
      callback={handleJoyrideCallback}
    />
  );
};

export default GuidedTour;
